export default __webpack_public_path__ + "static/media/pic2.5100fbc8.jpg";